import {
  ALL_POST_CONTENT_TYPES,
  type PostContentType,
} from "@dialogueconsulting/post-content-type";

/** Types added to the filter after explicit selections were first saved. */
export const NEWLY_ADDED_POST_CONTENT_TYPES: readonly PostContentType[] = [
  "document",
];

/**
 * An explicit list saved before NEWLY_ADDED_POST_CONTENT_TYPES existed gains
 * them, so a later uncheck sticks. A list holding "*" already means every type.
 * Returns the same list when nothing is added.
 */
export const withNewlyAddedPostContentTypes = <T>(
  selected: T[]
): (T | PostContentType)[] => {
  if (selected.includes(ALL_POST_CONTENT_TYPES as T)) return selected;
  const missing = NEWLY_ADDED_POST_CONTENT_TYPES.filter(
    (value) => !selected.includes(value as T)
  );
  return missing.length > 0 ? [...selected, ...missing] : selected;
};
